import {
  useCreateBankTransaction,
  useGetBankTransaction,
} from 'api-hooks/transactions/bank-transaction';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { DetailContainer } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import { NavigationProps } from 'types';

import { BankTransactionForm } from './components/form';

export type BankTransactionsViewParams = {
  id: string;
};

export default function BankTransactionsView(
  props: NavigationProps<NavigationRoutes.BankTransactionsView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetBankTransaction(
    {
      id,
    },
  );

  const { mutateAsync, error: errorMutate } = useCreateBankTransaction();

  const bankTransaction = data?.data;

  const onResolve = useApprovalableEdit('bank-transactions');

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          {!!errorMutate && !!errorMutate.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => errorMutate.message}
              </Notification>
            </>
          )}
          <BankTransactionForm
            {...props}
            bankTransaction={bankTransaction}
            onSubmit={async (input, form) => {
              const result = await mutateAsync(input);
              onResolve(result);
              return result.data;
            }}
          />
        </>
      }
    />
  );
}
